/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import React from "react";
import getQRCodeStatus from "../getQRCodeStatus";
import QRCodeIcon from "../../../Common/Svgs/QRCodeIcon";
import ListDropdown from "../ListDropdown";
import SubmittedDetails from "../../../Core/Components/SubmittedDetails";

export const QR_CODE_TYPE = {
  TRIKE: 1,
  BATTERY: 2,
  FARMER: 3,
  CHARGER: 4,
  TILLER: 5,
  MILLER: 6,
  WATER_PUMP: 7,
  THRESHER: 8,
  CHAUF_CUTTER: 9,
  CANISTER: 10,
  CRATE: 11,
  LOCKER: 12,
};

export const typeFilters = [
  {
    id: 1,
    value: getQRCodeStatus(1),
  },
  {
    id: 2,
    value: getQRCodeStatus(2),
  },
  {
    id: 3,
    value: getQRCodeStatus(3),
  },
  {
    id: 4,
    value: getQRCodeStatus(4),
  },
  {
    id: 5,
    value: getQRCodeStatus(5),
  },
  {
    id: 6,
    value: getQRCodeStatus(6),
  },
  {
    id: 7,
    value: getQRCodeStatus(7),
  },
  {
    id: 8,
    value: getQRCodeStatus(8),
  },
  {
    id: 9,
    value: getQRCodeStatus(9),
  },
  {
    id: 10,
    value: getQRCodeStatus(10),
  },
  {
    id: 11,
    value: getQRCodeStatus(11),
  },
  {
    id: 12,
    value: getQRCodeStatus(12),
  },
];

export const qrCodeColumns = [
  // {
  //   title: () => <UnselectAll />,
  //   dataIndex: 'id',
  //   width: '40px',
  //   render: (text) => <CheckboxCTA id={text} />,
  // },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Code ID
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a.id - b.id,
    width: "23%",
    render: (text) => (
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-black">
          {text}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Asset Type
      </div>
    ),
    width: "23%",
    dataIndex: "assetType",
    sorter: (a, b) => a.assetType - b.assetType,
    render: (text) => <div>{getQRCodeStatus(text)}</div>,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Asset ID
      </div>
    ),
    width: "23%",
    dataIndex: "assetId",
    sorter: (a, b) => a?.assetId?.localeCompare(b?.assetId),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date Of Entry
      </div>
    ),
    width: "23%",
    dataIndex: "submittedBy",
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    render: (text, record) => (
      <div>
        <SubmittedDetails record={record} />
      </div>
    ),
  },
  {
    dataIndex: "id",
    width: "100px",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown data={record} />
      </button>
    ),
  },
];

export const threeDotsOptions = [
  {
    id: 1,
    value: "View QR Code",
    icon: <QRCodeIcon className="text-dark-gray group-hover:text-black" />,
  },
];
